// Used by practitioner roles.
import { handleActions } from 'redux-actions';
import { assocPath, pipe } from 'ramda';

import {
  requestQuestionnaireResponse,
  requestQuestionnaireResponseFailure,
  requestQuestionnaireResponseSuccess,
} from 'store/actionCreators/questionnaireResponses';

import { requestPatientUpdateSuccess } from 'store/actionCreators/patientsData';

const defaultState = {};

export default handleActions(
  {
    [requestQuestionnaireResponse]: (state, { payload: { patientId } }) =>
      assocPath([patientId, 'loading'], true, state),
    [requestQuestionnaireResponseSuccess]: (
      state,
      {
        payload: { response },
        meta: {
          primaryPayload: { patientId },
        },
      },
    ) =>
      pipe(
        assocPath([patientId, 'loading'], false),
        assocPath([patientId, 'data'], response),
      )(state),
    [requestPatientUpdateSuccess]: (
      state,
      {
        payload: {
          response: { updatedQResponse },
        },
        meta: {
          primaryPayload: { id },
        },
      },
    ) => assocPath([id, 'data'], updatedQResponse, state),
    [requestQuestionnaireResponseFailure]: (
      state,
      {
        meta: {
          primaryPayload: { patientId },
        },
      },
    ) => assocPath([patientId, 'loading'], false)(state),
  },
  defaultState,
);
